import { render } from "./MemoryCPUStats.vue?vue&type=template&id=838d35f0&scoped=true"
import script from "./MemoryCPUStats.vue?vue&type=script&lang=js"
export * from "./MemoryCPUStats.vue?vue&type=script&lang=js"

import "./MemoryCPUStats.vue?vue&type=style&index=0&id=838d35f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838d35f0"]])

export default __exports__